import { normalizarData, normalizarValor } from '../../utils/index';

/**
 * Retorna TRUE se o array de dados se parecer com um extrato bancário do Santander.
 */
export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 20); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        // Verifica as colunas chaves do extrato Santander
        if (
            cleanRow.includes('data') && 
            cleanRow.includes('histórico') && 
            cleanRow.includes('documento') &&
            cleanRow.includes('valor') &&
            cleanRow.includes('saldo')
        ) {
            return true;
        }
    }
    return false;
};

/**
 * Processa o extrato bancário extraindo as entradas na conta (apenas créditos).
 */
export const processar = (dadosArray) => {
    let idxData = -1;
    let idxHistorico = -1;
    let idxDocumento = -1;
    let idxValor = -1;
    let idxCabecalho = -1;

    // 1. Encontrar o cabeçalho
    for (let i = 0; i < Math.min(dadosArray.length, 20); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        const possibleDataIdx = cleanRow.indexOf('data');
        const possibleHistoricoIdx = cleanRow.indexOf('histórico');
        const possibleDocumentoIdx = cleanRow.indexOf('documento');
        const possibleValorIdx = cleanRow.indexOf('valor');

        if (possibleDataIdx !== -1 && possibleHistoricoIdx !== -1 && possibleValorIdx !== -1) {
            idxCabecalho = i;
            idxData = possibleDataIdx;
            idxHistorico = possibleHistoricoIdx;
            idxDocumento = possibleDocumentoIdx;
            idxValor = possibleValorIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho do Extrato Santander não encontrado.');
    }

    const extrato = [];

    // 2. Extrair dados
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const dataStr = String(linha[idxData] || '').trim();
        if (!dataStr) continue;

        // Ignorar linha de saldo inicial/final se houver
        const historicoRaw = String(linha[idxHistorico] || '').trim();
        if (historicoRaw.toLowerCase().includes('saldo')) continue;

        const data = normalizarData(dataStr);
        if (!data) continue;

        let valorStr = String(linha[idxValor] || '').trim();
        if (!valorStr) continue;

        // Extrai valor limpo (substitui ',' por '.') - se a conversão falhar ignora
        // O Santander envia negativos com "-" na frente (Ex: -750,00)
        let valorNum = parseFloat(valorStr.replace(/[R$\s]/g, '').replace(/\./g, '').replace(',', '.'));
        
        // Se usar o normalizarValor, ele pode dar Math.abs(), o que não queremos se for débito. 
        // Então vamos ignorar valores negativos primeiro.
        if (isNaN(valorNum) || valorNum <= 0) continue;

        // Passamos pelo normalizarValor de segurança caso precise (já validamos ser numérico > 0)
        const valorLiquido = normalizarValor(valorStr);

        let documento = idxDocumento !== -1 ? String(linha[idxDocumento] || '').trim() : '';
        
        // Limpar múltiplos espaços em branco no meio do histórico do Santander
        const historicoLimpo = historicoRaw.replace(/\s+/g, ' ');

        extrato.push({
            linha: i + 1,
            data: data,
            valor: valorLiquido,
            tipo: 'Crédito', // Para bater com o agrupamento
            documento: documento,
            descricao: historicoLimpo,
            historico: historicoLimpo
        });
    }

    return extrato;
};
